import { facadeFactory } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { MbQuoteInfoModel } from '../../models'
import { CHECKOUT_CORE_FEATURE } from '@spartacus/checkout/base/root'

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: MbCheckoutQuoteInfoFacade,
      feature: CHECKOUT_CORE_FEATURE,
      methods: [
        'postQuoteInfoDetails'
      ],
      async: true,
    }),
})
export abstract class MbCheckoutQuoteInfoFacade {
  /**
   * Post quote info details
   *
   * @param quoteInfoDetails : the quoteInfoDetails to be set
   */
  abstract postQuoteInfoDetails(quoteInfoDetails: MbQuoteInfoModel): void
}
